import Credit from "./Credit.js";
import defined from "./defined.js";
import Resource from "./Resource.js";
let defaultTokenCredit;
const defaultAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhMzVlNTU2ZC1lYmM1LTQ2OWEtODRhOS0wYTFkODZmZTQ0OTgiLCJpZCI6MjU5LCJpYXQiOjE3NzI0ODIxOTR9.1oVHvVA9yr1C3CbLjlzcQQUyBuUuNaNCcc9_Giy8t7U";
/**
 * Default settings for accessing the Cesium ion API.
 *
 * An ion access token is only required if you are using any ion related APIs.
 * A default access token is provided for evaluation purposes only.
 * Sign up for a free ion account and get your own access token at {@link https://cesium.com}
 *
 * @see IonResource
 * @see IonImageryProvider
 * @see IonGeocoderService
 * @see createWorldImagery
 * @see createWorldTerrain
 * @namespace Ion
 */
const Ion = {};

/**
 * Gets or sets the default Cesium ion access token.
 *
 * @type {string}
 */
Ion.defaultAccessToken = defaultAccessToken;

/**
 * Gets or sets the message used when default Cesium ion access token is used.
 * This is needed for terriajs message override.
 *
 * @type {string}
 */
Ion.defaultTokenMessage = '<b> \
        This application is using Cesium\'s default ion access token. Please assign <i>Cesium.Ion.defaultAccessToken</i> \
        with an access token from your ion account before making any Cesium API calls. \
        You can sign up for a free ion account at <a href="https://cesium.com">https://cesium.com</a>.</b>';

/**
 * Gets or sets the default Cesium ion server.
 *
 * @type {string|Resource}
 * @default https://api.cesium.com
 */
Ion.defaultServer = new Resource({
  url: "https://api.cesium.com/"
});
Ion.getDefaultTokenCredit = function (providedKey) {
  if (providedKey !== defaultAccessToken) {
    return undefined;
  }
  if (!defined(defaultTokenCredit)) {
    defaultTokenCredit = new Credit(Ion.defaultTokenMessage, true);
  }
  return defaultTokenCredit;
};
export default Ion;